import { useTranslation } from "react-i18next"

export const useDateTranslations = (): Translations => {
  const { t } = useTranslation()
  const { t: tCommon } = useTranslation("common")

  return {
    dayLabel: t("dateFormatSelectWidget.dayLabel") || defaultTranslations.dayLabel,
    weekLabel: tCommon("week.long") || defaultTranslations.weekLabel,
    shortWeekLabel: tCommon("week.short") || defaultTranslations.shortWeekLabel,
    monthLabel: t("dateFormatSelectWidget.monthLabel") || defaultTranslations.monthLabel,
    fullDayNames: [
      tCommon("days.long.0") || defaultTranslations.fullDayNames[0],
      tCommon("days.long.1") || defaultTranslations.fullDayNames[1],
      tCommon("days.long.2") || defaultTranslations.fullDayNames[2],
      tCommon("days.long.3") || defaultTranslations.fullDayNames[3],
      tCommon("days.long.4") || defaultTranslations.fullDayNames[4],
      tCommon("days.long.5") || defaultTranslations.fullDayNames[5],
      tCommon("days.long.6") || defaultTranslations.fullDayNames[6],
    ],
    abbreviatedDayNames: [
      tCommon("days.3alpha.0") || defaultTranslations.abbreviatedDayNames[0],
      tCommon("days.3alpha.1") || defaultTranslations.abbreviatedDayNames[1],
      tCommon("days.3alpha.2") || defaultTranslations.abbreviatedDayNames[2],
      tCommon("days.3alpha.3") || defaultTranslations.abbreviatedDayNames[3],
      tCommon("days.3alpha.4") || defaultTranslations.abbreviatedDayNames[4],
      tCommon("days.3alpha.5") || defaultTranslations.abbreviatedDayNames[5],
      tCommon("days.3alpha.6") || defaultTranslations.abbreviatedDayNames[6],
    ],
    shortDayNames: [
      tCommon("days.2alpha.0") || defaultTranslations.shortDayNames[0],
      tCommon("days.2alpha.1") || defaultTranslations.shortDayNames[1],
      tCommon("days.2alpha.2") || defaultTranslations.shortDayNames[2],
      tCommon("days.2alpha.3") || defaultTranslations.shortDayNames[3],
      tCommon("days.2alpha.4") || defaultTranslations.shortDayNames[4],
      tCommon("days.2alpha.5") || defaultTranslations.shortDayNames[5],
      tCommon("days.2alpha.6") || defaultTranslations.shortDayNames[6],
    ],
    narrowDayNames: [
      tCommon("days.1alpha.0") || defaultTranslations.narrowDayNames[0],
      tCommon("days.1alpha.1") || defaultTranslations.narrowDayNames[1],
      tCommon("days.1alpha.2") || defaultTranslations.narrowDayNames[2],
      tCommon("days.1alpha.3") || defaultTranslations.narrowDayNames[3],
      tCommon("days.1alpha.4") || defaultTranslations.narrowDayNames[4],
      tCommon("days.1alpha.5") || defaultTranslations.narrowDayNames[5],
      tCommon("days.1alpha.6") || defaultTranslations.narrowDayNames[6],
    ],
    fullMonthNames: [
      tCommon("months.long.0") || defaultTranslations.fullMonthNames[0],
      tCommon("months.long.1") || defaultTranslations.fullMonthNames[1],
      tCommon("months.long.2") || defaultTranslations.fullMonthNames[2],
      tCommon("months.long.3") || defaultTranslations.fullMonthNames[3],
      tCommon("months.long.4") || defaultTranslations.fullMonthNames[4],
      tCommon("months.long.5") || defaultTranslations.fullMonthNames[5],
      tCommon("months.long.6") || defaultTranslations.fullMonthNames[6],
      tCommon("months.long.7") || defaultTranslations.fullMonthNames[7],
      tCommon("months.long.8") || defaultTranslations.fullMonthNames[8],
      tCommon("months.long.9") || defaultTranslations.fullMonthNames[9],
      tCommon("months.long.10") || defaultTranslations.fullMonthNames[10],
      tCommon("months.long.11") || defaultTranslations.fullMonthNames[11],
    ],
    shortMonthsNames: [
      tCommon("months.short.0") || defaultTranslations.shortMonthsNames[0],
      tCommon("months.short.1") || defaultTranslations.shortMonthsNames[1],
      tCommon("months.short.2") || defaultTranslations.shortMonthsNames[2],
      tCommon("months.short.3") || defaultTranslations.shortMonthsNames[3],
      tCommon("months.short.4") || defaultTranslations.shortMonthsNames[4],
      tCommon("months.short.5") || defaultTranslations.shortMonthsNames[5],
      tCommon("months.short.6") || defaultTranslations.shortMonthsNames[6],
      tCommon("months.short.7") || defaultTranslations.shortMonthsNames[7],
      tCommon("months.short.8") || defaultTranslations.shortMonthsNames[8],
      tCommon("months.short.9") || defaultTranslations.shortMonthsNames[9],
      tCommon("months.short.10") || defaultTranslations.shortMonthsNames[10],
      tCommon("months.short.11") || defaultTranslations.shortMonthsNames[11],
    ],
  }
}

const defaultTranslations = {
  dayLabel: "Day",
  weekLabel: "Week",
  shortWeekLabel: "wk",
  monthLabel: "Month",
  fullDayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  abbreviatedDayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  shortDayNames: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  narrowDayNames: ["S", "M", "T", "W", "T", "F", "S"],
  fullMonthNames: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  shortMonthsNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
}

type Translations = typeof defaultTranslations
